<template>
  <div class="full-jcalendar" :style="{width:width}">
    <!--日期控件弹窗主体-->
    <div class="full-jcalendar__main">
      <!--单日期模式-->
      <div>
        <div class="full-jcalendar-header">
          <span class="title-year">{{year}}年</span>
          <span style="width:10px;"></span>
          <span class="title-month" @click="monthVisible = true">{{month}}月</span>
          <!-- header 切换月份 -->
          <!-- <p class="prev-month" @click.stop="goPrev">
            <i class="el-icon-arrow-left"></i>
          </p>
          <p class="next-month" @click.stop="goNext">
            <i class="el-icon-arrow-right"></i>
          </p>-->
        </div>
        <!-- body  日期和事件 -->
        <div class="full-jcalendar__body">
          <div class="weeks">
            <strong class="week">日</strong>
            <strong class="week">一</strong>
            <strong class="week">二</strong>
            <strong class="week">三</strong>
            <strong class="week">四</strong>
            <strong class="week">五</strong>
            <strong class="week">六</strong>
          </div>
          <!--日期 周  行-->
          <div class="week-row" v-for="(week,$index) in calendarDatas" :key="$index">
            <!--日期 日  单元格-->
            <div
              class="day-cell"
              v-for="(day,$index) in week"
              :key="$index"
              :class="[{'today': day.isToday,'not-cur-month': !day.isCurMonth,'select':day.isSelect,}]"
              @click="onDateSelect(day)"
            >
              <!-- 日期 节气 农历 -->
              <div class="day-number">
                <p class="solar">
                  <span :class="['number',{'is-today':day.isToday}]">{{day.day}}</span>
                </p>
                <i v-if="day.isClock" class="warning"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- 月份切换 -->
        <div class="full-jcalendar__month" v-show="monthVisible">
          <div class="full-jcalendar-header">
            <span>{{month}}月</span>
          </div>

          <div class="full-jcalendar__body">
            <ul class="data-list">
              <li @click="onMonthSelect(m-1)" v-for="m in 12" :key="m">{{m}}月</li>
            </ul>
            <p class="clearfix"></p>
            <p class="close" @click="monthVisible=false">取 消</p>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import { calendar } from "./datePicker.js";
import moment from "moment";
export default {
  name: "date",
  props: ["width", "pickerOptions", "workdata", "startMonth"],
  data() {
    return {
      monthDay: "", //月份日期类型，用来比较日期
      year: 0,
      month: 0,
      calendarDatas: [],
      monthVisible: false //月份选择开关
    };
  },
  created() {
    let month = moment();
    this.monthDay = month.toISOString();
    this.loadCalendar();
    document.addEventListener("click", e => {
      let main = this.$el.querySelector(".full-jcalendar__main");
    });
  },
  methods: {
    onDateSelect(day) {
      this.calendarDatas.map(item => {
        item.map(val => {
          val.isSelect = false;
        });
      });
      day.isSelect = !day.isSelect;
      this.$emit("on-date-select", day);
    },
    loadCalendar() {
      if (this.monthDay == null || this.monthDay == "") {
        this.monthDay = moment().toISOString();
      }
      let startDate = moment(this.monthDay)
        .startOf("month")
        .format("YYYY-MM-DD");
      let currentMonth = moment(startDate);
      this.year = currentMonth.year();
      this.month = currentMonth.month() + 1;
      this.calendarDatas = this.handleCalendar(currentMonth);
    },
    handleCalendar(currentMonth) {
      let start = currentMonth.clone();
      start.subtract(start.day(), "d");
      let calendars = [];
      for (let iWeek = 0; iWeek < 6; iWeek++) {
        let week = [];
        if (iWeek > 0 && !start.isSame(currentMonth, "month")) {
          break;
        }
        for (let iDay = 0; iDay < 7; iDay++) {
          week.push({
            day: start.date(),
            isToday: start.isSame(new Date(), "day"),
            isCurMonth: start.isSame(currentMonth, "month"),
            week: iDay,
            isSelect: false,
            date: start.clone().format("YYYY-MM-DD"),
            isClock: this.workdata[start.clone().format("YYYY-MM-DD")]
          });
          start.add(1, "d");
        }
        calendars.push(week);
      }
      return calendars;
    },
    goPrev() {
      let newMonth = moment(this.monthDay).subtract(1, "months");
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
    },
    goNext() {
      let newMonth = moment(this.monthDay).add(1, "months");
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
    },
    onMonthSelect(command) {
      let newMonth = moment(this.monthDay).month(command);
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
      this.monthVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("../../scss/calendar.scss");
.full-jcalendar__body {
  .day-cell:before {
    content: "";
    width: 0px;
    height: 0px;
  }
  .warning {
    background: #f56c6c;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/OACalendar/date.vue